import { render, staticRenderFns } from "./MStoreMultiValueReferences.vue?vue&type=template&id=5d990778&"
import script from "./MStoreMultiValueReferences.vue?vue&type=script&lang=ts&"
export * from "./MStoreMultiValueReferences.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports